module.exports = __webpack_public_path__ + "img/brand-npm.8f3b2ec6.svg";